import React, {useState, useCallback, useEffect} from 'react';
import {Box, Typography} from "@mui/material";

export const SwipeHint = ({timeout}:{timeout?:number}) => {
    const [showSwipeHint, setShowSwipeHint] = useState(false);
    if(!timeout)
        timeout=4000;
    useEffect(() => {
        if (window.innerWidth <= 768) {
            setShowSwipeHint(true);
            const timer = setTimeout(() => {
                setShowSwipeHint(false);
            }, timeout);
            return () => clearTimeout(timer);
        }
    }, [timeout]);
    return !showSwipeHint ? <span></span>
        : <Box display="flex" justifyContent="center" mb={2}>
            <Typography variant="body2" sx={{ color: 'gray' }}>
                👈 Двигайте для просмотра 👉
            </Typography> 
    </Box>
}
